export default "__VITE_ASSET__BUzu03T3__"